import type { NodeViewProps } from "@tiptap/react";

import { Input } from "@/components/ui/input";

/**
 * Text field sub-view — simple text input for short atomic values.
 *
 * Used where atomic metadata content is a short text string rather than
 * a rich text section or an enum choice.
 */
export function TextFieldView({ node, updateAttributes }: NodeViewProps) {
  const currentValue = (node.attrs.value as string) || "";
  const label = node.attrs.label as string;
  const guidance = node.attrs.guidance as string | undefined;

  return (
    <Input
      value={currentValue}
      onChange={(e) => updateAttributes({ value: e.target.value })}
      placeholder={guidance || `Enter ${label.toLowerCase()}...`}
      className="max-w-md"
    />
  );
}
